export default __webpack_public_path__ + "static/saoldisplay-regularitalic-webfont-b1b56c54c15ed68e6cf93b5774964136.woff2";